import { Component, Inject, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../_shared/shared.module';
import { MaterialModule } from '../../material/material.module';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IconService } from '../../_core/services/icon.service';
import {
  FormFieldList,
  SfAmountInputFormField,
  SfInputFormField,
  SmartFormComponent,
} from 'ngx-smart-form';
import { BudgetDetailsService } from '../../_core/services/budget-details.service';

@Component({
  selector: 'app-budget-details-edit-years-dialog',
  standalone: true,
  imports: [SharedModule, MaterialModule],
  templateUrl: './budget-details-edit-years-dialog.component.html',
  styleUrls: ['./budget-details-edit-years-dialog.component.scss'],
})
export class BudgetDetailsEditYearsDialogComponent {
  @ViewChild(SmartFormComponent) smartFormComponent?: SmartFormComponent<{
    previous: string;
    current: string;
  }>;

  fields: FormFieldList<{ previous: string; current: string }>;
  constructor(
    public dialogRef: MatDialogRef<
      BudgetDetailsEditYearsDialogComponent,
      boolean
    >,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      previous: string;
      current: string;
      id: string;
    },
    iconService: IconService,
    private budgetDetailsService: BudgetDetailsService
  ) {
    iconService.getIcons(['edit']);
    this.fields = [
      [
        new SfInputFormField({
          formControlName: 'previous',
          label: 'Anno precedente',
          placeholder: 'Esempio: 2022',
          required: true,
          value: data.previous,
        }),
        new SfInputFormField({
          formControlName: 'current',
          label: 'Anno corrente',
          placeholder: 'Esempio: 2023',
          required: true,
          value: data.current,
        }),
      ],
    ];
  }

  edit() {
    if (this.smartFormComponent?.form.valid) {
      this.budgetDetailsService
        .editYears(
          {
            annoPrecedente: this.smartFormComponent.form.value.previous!,
            annoCorrente: this.smartFormComponent.form.value.current!,
          },
          this.data.id
        )
        .subscribe(() => {
          this.dialogRef.close(true);
        });
    }
  }
}
